var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "file-type-jpg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.25,
    height: 30,
    viewBox: "0 0 23.25 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M16.483,0H.791C.354,0,0,.351,0,1.032V29.464c0,.185.354.536.791.536H22.459c.437,0,.791-.351.791-.536V6.952c0-.373-.05-.493-.139-.581L16.819.138A.48.48,0,0,0,16.483,0Z",
    fill: "#f2f2e8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M22.349.108V6.455h6.407Z",
    transform: "translate(-5.587 -0.027)",
    fill: "#d9d7ca"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M22.459,36.964H.791A.787.787,0,0,1,0,36.181V27.857H23.25v8.323A.787.787,0,0,1,22.459,36.964Z",
    transform: "translate(0 -6.965)",
    fill: "#14a085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M10.217,30.65v4.095a1.309,1.309,0,0,1-.136.624,1.118,1.118,0,0,1-.364.406,1.451,1.451,0,0,1-.524.214,3.014,3.014,0,0,1-.61.061,2.476,2.476,0,0,1-.367-.032,3.132,3.132,0,0,1-.435-.1q-.225-.068-.431-.153A1.576,1.576,0,0,1,7,35.572l.364-.578a1.066,1.066,0,0,0,.2.1c.088.035.184.069.289.1s.214.058.328.082a1.563,1.563,0,0,0,.321.035,1.1,1.1,0,0,0,.6-.146.577.577,0,0,0,.239-.5V30.65Z",
    transform: "translate(-1.75 -7.662)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M13.848,36.05h-.856V30.792H14.5a2.123,2.123,0,0,1,.663.107,1.8,1.8,0,0,1,.589.321,1.676,1.676,0,0,1,.421.517,1.433,1.433,0,0,1,.161.681,1.865,1.865,0,0,1-.136.724,1.513,1.513,0,0,1-.378.546,1.7,1.7,0,0,1-.585.342,2.251,2.251,0,0,1-.756.121h-.635v1.9Zm0-4.608v2.083h.785a.932.932,0,0,0,.31-.054.782.782,0,0,0,.282-.175.854.854,0,0,0,.207-.339,1.605,1.605,0,0,0,.078-.538,1.457,1.457,0,0,0-.035-.3.854.854,0,0,0-.146-.321.864.864,0,0,0-.31-.257,1.148,1.148,0,0,0-.528-.1Z",
    transform: "translate(-3.248 -7.698)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M22.555,33.311v2.033a1.537,1.537,0,0,1-.367.339,2.243,2.243,0,0,1-.428.218,2.207,2.207,0,0,1-.464.121,3.049,3.049,0,0,1-.474.037,2.156,2.156,0,0,1-.867-.171,1.94,1.94,0,0,1-.692-.507,2.391,2.391,0,0,1-.464-.842,4.156,4.156,0,0,1,0-2.336,2.379,2.379,0,0,1,.464-.838,1.974,1.974,0,0,1,.7-.51,2.123,2.123,0,0,1,.863-.175,2.209,2.209,0,0,1,.8.142,1.948,1.948,0,0,1,.663.428l-.592.528a1.019,1.019,0,0,0-.392-.3,1.176,1.176,0,0,0-.457-.093,1.286,1.286,0,0,0-.5.1,1.077,1.077,0,0,0-.428.339,1.744,1.744,0,0,0-.3.617,3.642,3.642,0,0,0-.114.927,3.871,3.871,0,0,0,.111.927,1.9,1.9,0,0,0,.285.642,1.216,1.216,0,0,0,.414.371,1.038,1.038,0,0,0,.489.121c.052,0,.122,0,.21-.011a2.549,2.549,0,0,0,.264-.035,1.726,1.726,0,0,0,.253-.068.363.363,0,0,0,.178-.121V33.9h-.892V33.31h1.741Z",
    transform: "translate(-4.658 -7.67)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M4,23l5.5-9,3.85,5.294,2.75-3.176L20.5,23Z",
    transform: "translate(-1 -3.5)",
    fill: "#26b99a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 2.029,
    cy: 2.029,
    r: 2.029,
    transform: "translate(3.262 4.871)",
    fill: "#c6c9cc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.fb5136bbf256b80062c0a0825a5a8723.svg";
export { ForwardRef as ReactComponent };